<template>
  <div id="keys">
    <Datatable
      class="datatable"
      ref="datatable"
      entity="apiKey"
      :parameters="{
        branch: branch || undefined,
      }"
      :globalActions="[
        {text: 'apiKeys.create', method: onCreateApiKey, condition: () => $store.getters.loggedUserHasModifyPermission}
      ]"
      :rowActions="[
        {text: 'apiKeys.showKey', method: onRowShowKey},
        {text: 'datatable.delete', method: onRowDelete, condition: () => $store.getters.loggedUserHasModifyPermission}
      ]"
    />

    <Modal
      dismissable
      name="create"
      :title="$t('apiKeys.createModal.title')"
      :actions="[
        {name: $t('back'), action: 'close'},
        {name: $t('create'), action: () => saveApiKeyData(apiKey), primary: true}
      ]">
      <div class="group">
        <label>{{$t('branch.title')}}</label>
        <AjaxSelect
          v-model="apiKey.branch"
          api="/api/entity/branch/select"
          :map-fn="(b) => b.name"
          :allow-empty-search="true"
        />
      </div>
      <div class="group">
        <label>User</label>
        <AjaxSelect
          v-model="apiKey.user"
          api="/api/entity/user/select"
          :query="{branch: apiKey.branch.id}"
          :map-fn="(b) => b.username"
          :allow-empty-search="false"
        />
      </div>
      <div class="group">
        <label>{{$t('description')}}</label>
        <input type="text" v-model="apiKey.description">
      </div>
    </Modal>

    <Modal
      dismissable
      name="confirmation"
      :title="confirmationModal.title"
      :actions="[
        {name: $t('back'), action: 'close'},
        {name: confirmationModal.actionName, action: confirmationModal.actionCallback, primary: true}
      ]">
      <p v-html="confirmationModal.body"></p>
      <input v-model="confirmationModal.textPrompt" type="text" class="w-100"/>
    </Modal>

    <Modal
      dismissable
      name="showText"
      :title="showModal.title"
      :actions="[
        {name: $t('back'), action: 'close'}
      ]">
      <p v-html="showModal.body"></p>
    </Modal>

  </div>
</template>

<script>
import Datatable from "@/components/Datatable.vue";
import AjaxSelect from "@/components/tools/AjaxSelect";
import {mapActions} from "vuex";

export default {
  name: "ApiKeys",
  components: {AjaxSelect, Datatable},

  data() {
    return {
      apiKey: {
        branch: {id: null},
        user: {id: null},
        description: null
      },
      confirmationModal: {
        title: '',
        body: '',
        textPrompt: '',
        actionName: '',
        actionCallback: ''
      },
      showModal: {
        title: '',
        body: ''
      }
    }
  },

  computed: {
    branch() {
      return null;
    }
  },

  watch: {
    'apiKey.branch.id'() {
      this.apiKey.user = {id: null};
    }
  },

  methods: {

    ...mapActions(['getApiKey', 'saveApiKey', 'deleteApiKey']),

    onCreateApiKey() {
      this.apiKey.branch = {id: null};
      this.apiKey.user = {id: null};
      this.apiKey.description = null;
      this.$modal.show('create', true);
    },

    async saveApiKeyData(data) {
      this.$modal.show('create', false);

      let copy = JSON.parse(JSON.stringify(data));
      copy.branch = undefined;
      copy.user = data.user.id;

      this.$store.commit('showSpinner', true);
      let response = await this.saveApiKey({data: copy});
      this.$store.commit('showSpinner', false);

      if (response) {
        toast(this.$t('apiKeys.saved'), 'success');
        this.showKey(response);
        await this.$refs.datatable.query();
      } else {
        toast(this.$t('error.no_server'), 'error');
      }
    },

    async onRowShowKey(row) {
      this.$store.commit('showSpinner', true);
      let response = await this.getApiKey({keyId: row.id});
      this.$store.commit('showSpinner', false);

      if (response) {
        this.showKey(response);
      }
    },

    showKey(data) {
      this.showModal.title = this.$t('apiKeys.showKeyModal.title').replace('%NAME%', data.user.username);
      this.showModal.body = data.apiKey;
      this.$modal.show('showText', true);
    },

    onRowDelete(row) {
      this.confirmationModal.title = this.$t('apiKeys.deleteModal.title');
      this.confirmationModal.body = this.$t('apiKeys.deleteModal.body').replace('%NAME%', row.username);
      this.confirmationModal.textPrompt = '';
      this.confirmationModal.actionName = this.$t('datatable.delete');
      this.confirmationModal.actionCallback = () => this.onRowDeleteConfirm(row);
      this.$modal.show('confirmation');
    },

    async onRowDeleteConfirm(row) {
      this.$modal.show('confirmation', false);

      if (this.confirmationModal.textPrompt !== row.username) {
        toast(this.$t('apiKeys.deleteModal.no_match'), 'error');
        return;
      }
      this.$store.commit('showSpinner', true);
      let response = await this.deleteApiKey({keyId: row.id});
      this.$store.commit('showSpinner', false);

      if (response) {
        toast(this.$t('apiKeys.deleted'), 'success');
        await this.$refs.datatable.query();
      } else {
        toast(this.$t('error.no_server'), 'error')
      }
    }
  }

}
</script>

<style lang="scss" scoped>

</style>